module.exports = __webpack_public_path__ + "img/jstree_checkbox_check.278afcb.png";